<!-- eslint-disable no-tabs -->
<template>
	<div class="trabajos__content__grid trabajos__content__grid--mobile">
		<hooper
			class="row-odd"
			group="1"
			:items-to-show="5"
			:items-to-slide="1"
			:infinite-scroll="true"
      :vertical="true"
			:wheel-control="false"
      :settings="hooperSettings"
		>
		<slide class="item" v-for="trabajo in grilla1" :key="trabajo.slug">
				<img class="item__cover" :src="trabajo.cover" @click="selectWork(trabajo)">
				<button class="expand" @click="selectWork(trabajo)">
					<img src="/img/png/expand.png" />
				</button>
			</slide>
		</hooper>
		<hooper
			class="row-even"
			group="1"
			:items-to-show="5"
			:items-to-slide="1"
			:infinite-scroll="true"
      :vertical="true"
			:wheel-control="false"
      :settings="hooperSettings"
		>
			<slide class="item" v-for="trabajo in grilla2" :key="trabajo.slug">
				<img class="item__cover" :src="trabajo.cover" @click="selectWork(trabajo)">
				<button class="expand" @click="selectWork(trabajo)">
					<img src="/img/png/expand.png" />
				</button>
			</slide>
			<hooper-pagination slot="hooper-addons"></hooper-pagination>
		</hooper>
	</div>
</template>

<script>
import {
  Hooper,
  Slide,
  Pagination as HooperPagination,
  Navigation as HooperNavigation
} from 'hooper'
import 'hooper/dist/hooper.css'

export default {
  props: {
    grilla1: {
      type: Array,
      required: true
    },
    grilla2: {
      type: Array,
      required: true
    }
  },
  components: {
    Hooper,
    Slide,
    HooperNavigation,
    HooperPagination
  },
  data () {
    return {
      selectedWork: null,
      hooperSettings: {
        itemsToShow: 5,
        breakpoints: {
          768: {
            itemsToShow: 6
          }
        }
      }
    }
  },
  methods: {
    selectWork (item) {
      this.$emit('select', item)
    }
  }
}
</script>
